import { render, staticRenderFns } from "./rulesOrderSetting.vue?vue&type=template&id=20c82b6d&scoped=true&"
import script from "./rulesOrderSetting.vue?vue&type=script&lang=js&"
export * from "./rulesOrderSetting.vue?vue&type=script&lang=js&"
import style0 from "./rulesOrderSetting.vue?vue&type=style&index=0&id=20c82b6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c82b6d",
  null
  
)

export default component.exports